import { render, staticRenderFns } from "./BaseSelectDropdown.vue?vue&type=template&id=3630b9bc"
import script from "./BaseSelectDropdown.vue?vue&type=script&lang=js"
export * from "./BaseSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectDropdown.vue?vue&type=style&index=0&id=3630b9bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports